import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Field, Form, Formik, useFormik } from "formik";
import config from "../../config/config";
import { Tabs, Tab } from "react-bootstrap";

const StoreAccountPaymentModal = (props) => {
  const [formValues, setFormValues] = useState({
    ID: 0,
    Name: "",
    Hidefromgrid: false,
    ParentID: 0,
    Color: "",
    Imagename: "",
    CategoryInfopopup: "",
  });

  const token = localStorage.getItem("Token");



 

 

  return (
    <>
      <div
        className="modal fade"
        id="StoreAccountPaymentModal"
        tabIndex={-1}
        aria-labelledby="upset"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-body">
              <button
                type="button"
                className="close float-end"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
              <Formik
                {...props}
                initialValues={formValues}
                // onSubmit={handleSubmit}
                enableReinitialize
              >
                {({ values, errors, touched, handleChange, handleBlur }) => (
                  <Form>
                    <Tabs
                      defaultActiveKey="Item"
                      id="form-tabs"
                      className="mb-4"
                    >
                      <Tab eventKey="Item" title="Item Info">
                        <div className="row">
                          <div className="col-12">
                            <div className="card">
                              <div className="card-header">
                                <h3> Item Information</h3>
                                <div className="position-relative">
                                  <Link
                                    className="position-absolute top-0 end-0 me-2"
                                    to={`/manage-items/${props.ID}`}
                                  >
                                    <i
                                      className="fa fa-edit text-warning fa-2x "
                                      title="Edit"
                                    ></i>
                                  </Link>
                                </div>

                                <table className="table table-bordered">
                                  <tr>
                                    <td>Category</td>
                                    <td>Store Account Payment</td>
                                  </tr>
                                  <tr>
                                    <td>Item Id</td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td>Product ID</td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td>Allow Alt Description</td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td>Item has Serial Number</td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td>Generate Barcodes</td>
                                    <td>Print</td>
                                  </tr>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Tab>
                      <Tab eventKey="pricing" title="Pricing">
                        <div className="row">
                          <div className="col-12">
                            <div className="card">
                              <div className="card-header">
                                <h3>Pricing</h3>
                                <Link
                                  className="position-absolute top-0 end-0 me-2"
                                  to={`/manage-items/${props.ID}`}
                                >
                                  <i
                                    className="fa fa-edit text-warning fa-2x "
                                    title="Edit"
                                  ></i>
                                </Link>
                                <table className="table table-bordered">
                                  <tr>
                                    <td>Selling Price</td>
                                    <td>$0.00</td>
                                  </tr>
                                  <tr>
                                    <td>Cost Price</td>
                                    <td></td>
                                  </tr>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Tab>
                      <Tab eventKey="inventory" title="Inventory">
                        <div className="row">
                          <div className="col-12">
                            <div className="card">
                              <div className="card-header">
                                <h3>Inventory</h3>
                                <Link
                                  className="position-absolute top-0 end-0 me-2"
                                  to={`/manage-items/${props.ID}`}
                                >
                                  <i
                                    className="fa fa-edit text-warning fa-2x "
                                    title="Edit"
                                  ></i>
                                </Link>
                                <div className="card">
                                  <div className="card-header">
                                    <h5>Default</h5>
                                    <table className="table table-bordered">
                                      <tr>
                                        <td>Quantity</td>
                                        <td>00</td>
                                      </tr>
                                      <tr>
                                        <td>Reorder Level</td>
                                        <td>Not set</td>
                                      </tr>
                                      <tr>
                                        <h5>RepairCenter</h5>
                                        <td>Quantity</td>
                                        <td>00</td>
                                      </tr>
                                      <tr>
                                        <td>Reorder Level</td>
                                        <td>Not set</td>
                                      </tr>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Tab>
                      <Tab eventKey="images" title="Images">
                        <div className="row">
                          <div className="col-12">
                            <div className="card">
                              <div className="card-header">
                                <h3>Images</h3>
                                <Link
                                  className="position-absolute top-0 end-0 me-2"
                                  to={`/manage-items/${props.ID}`}
                                >
                                  <i
                                    className="fa fa-edit text-warning fa-2x "
                                    title="Edit"
                                  ></i>
                                </Link>
                                <table className="table table-bordered"></table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Tab>
                    </Tabs>
                    <div className="col-lg-12 justify-content-right">
                      <button
                        type="submit"
                        className="btn btn-primary btn-md me-1"
                      >
                        Submit
                      </button>
                      <Link
                        to="#"
                        className="btn btn-dark btn-md me-1"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </Link>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StoreAccountPaymentModal;
